// Provider logos v9 — scherpere logo's via Google s2 128px (DuckDuckGo/SVG-fallback).
// Provider logos v8 — DuckDuckGo-icons als primaire bron (Clearbit is offline sinds eind 2025),
// mobiel.nl/MediaMarkt/50+ toegevoegd, en de favicon-fixer maakt door onerror verborgen imgs weer zichtbaar.
window.PV_LOGO_DOMAINS={
  odido:'odido.nl',vodafone:'vodafone.nl',ben:'ben.nl',simyo:'simyo.nl',
  kpn:'kpn.com',ziggo:'ziggo.nl',youfone:'youfone.nl',lebara:'lebara.nl',
  delta:'delta.nl',onlinenl:'online.nl',hollandsnieuwe:'hollandsnieuwe.nl',
  simpel:'simpel.nl',lycamobile:'lycamobile.nl',budget:'budgetthuis.nl',
  caiway:'caiway.nl',freedom:'freedom.nl',solcon:'solcon.nl',kliksafe:'kliksafe.nl',
  vijftigplus:'50plusmobiel.nl',letsgo:'letsgomobile.nl',mobielnl:'mobiel.nl',mediamarkt:'mediamarkt.nl'
};
window.PV_COLORS={odido:'#6b2d8b',vodafone:'#e60000',ben:'#0066cc',simyo:'#00b67a',kpn:'#00a550',ziggo:'#ff6200',youfone:'#e6007e',lebara:'#e4003a',delta:'#0072bc',onlinenl:'#ff7900',hollandsnieuwe:'#ff6600',simpel:'#e2001a',lycamobile:'#0055a5',budget:'#7c3aed',caiway:'#00a0df',freedom:'#111827',solcon:'#e87722',kliksafe:'#1d4ed8',vijftigplus:'#f59e0b',letsgo:'#0ea5e9',mobielnl:'#1B3FA0',mediamarkt:'#df0000'};
window.PV_DISPLAY={odido:'Odido',vodafone:'Vodafone',ben:'Ben',simyo:'Simyo',kpn:'KPN',ziggo:'Ziggo Meervoordeel',youfone:'Youfone',lebara:'Lebara',delta:'DELTA',onlinenl:'Online.nl',hollandsnieuwe:'hollandsnieuwe',simpel:'Simpel',lycamobile:'Lyca',budget:'Budget Thuis',caiway:'Caiway',freedom:'Freedom',solcon:'Solcon',kliksafe:'Kliksafe',vijftigplus:'50+ Mobiel',letsgo:"Let's Go",mobielnl:'Mobiel.nl',mediamarkt:'MediaMarkt'};
window.pvProvKey=function(n){
  var m=(n||'').toLowerCase();
  // VOLGORDE belangrijk: specifiekere merken EERST
  if(m.includes('mediamarkt')||m.includes('media markt'))return'mediamarkt';
  if(m.includes('mobiel.nl'))return'mobielnl';
  if(m.includes('hollandsnieuwe')||m.includes('hollands nieuwe'))return'hollandsnieuwe';
  if(m.includes('50plus')||m.includes('50 plus')||m.includes('50+'))return'vijftigplus';
  if(m.includes("let's go")||m.includes('lets go'))return'letsgo';
  if(m.includes('lyca'))return'lycamobile';
  if(m.includes('simyo'))return'simyo';
  if(/\bsimpel\b/.test(m))return'simpel';
  if(m.includes('online.nl')||m.includes('online nl'))return'onlinenl';
  if(m.includes('odido')||m.includes('t-mobile'))return'odido';
  if(m.includes('vodafone'))return'vodafone';
  if(/\bben\b/.test(m))return'ben';
  if(m.includes('kpn'))return'kpn';
  if(m.includes('ziggo'))return'ziggo';
  if(m.includes('youfone'))return'youfone';
  if(m.includes('lebara'))return'lebara';
  if(m.includes('delta'))return'delta';
  if(m.includes('budget'))return'budget';
  if(m.includes('caiway'))return'caiway';
  if(m.includes('freedom'))return'freedom';
  if(m.includes('solcon'))return'solcon';
  if(m.includes('kliksafe'))return'kliksafe';
  return '';
};
window.pvProvName=function(merchantName){
  var k=pvProvKey(merchantName);
  if(k&&PV_DISPLAY[k])return PV_DISPLAY[k];
  return (merchantName||'')
    .replace(/T-Mobile NL/gi,'Odido').replace(/T-Mobile/gi,'Odido')
    .replace(/Mobiel NL/gi,'').replace(/Thuis NL/gi,'').replace(/ NL\b/gi,'')
    .replace(/Zakelijk/gi,'').replace(/\s+/g,' ').trim();
};
// Officieel Meervoordeel-logo (SVG-asset in het thema). URL wordt door Liquid gezet in window.PV_MV_LOGO.
window.pvLogoBox=function(merchantName,size){
  size=size||56;
  var k=pvProvKey(merchantName);
  var fixed=pvProvName(merchantName)||merchantName||'';
  // Ziggo Meervoordeel: toon het echte Meervoordeel-logo i.p.v. een favicon.
  var _mn=(merchantName||'').toLowerCase();
  if((_mn.indexOf('meervoordeel')>=0 || _mn.indexOf('ziggo')>=0) && window.PV_MV_LOGO){
    var styMv='width:'+size+'px;height:'+size+'px;object-fit:contain;border-radius:10px;border:1.5px solid #e8edf5;background:#fff;padding:3px;flex-shrink:0;display:block;';
    return '<img src="'+window.PV_MV_LOGO+'" alt="Meervoordeel" width="'+size+'" height="'+size+'" style="'+styMv+'" loading="eager">';
  }
  var domain=PV_LOGO_DOMAINS[k];
  var color=PV_COLORS[k]||'#1B3FA0';
  var label=fixed.length<=8?fixed:(fixed.split(' ')[0]||'').substring(0,6);
  var fbSvg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">'
    +'<rect width="100" height="100" fill="'+color+'" rx="16"/>'
    +'<text x="50" y="62" font-family="Arial Black,Arial,sans-serif" '
    +'font-size="'+(label.length<=3?32:label.length<=5?24:label.length<=7?18:14)+'" '
    +'font-weight="900" fill="white" text-anchor="middle">'+label.toUpperCase()+'</text></svg>';
  var fbUri='data:image/svg+xml;base64,'+btoa(unescape(encodeURIComponent(fbSvg)));
  var sty='width:'+size+'px;height:'+size+'px;object-fit:contain;border-radius:10px;'
    +'border:1.5px solid #e8edf5;background:#fff;padding:2px;flex-shrink:0;display:block;';
  if(domain){
    // Scherper: vraag een 128px-icoon op (scherp op retina), val terug op DuckDuckGo, dan de SVG-tegel.
    var hi='https://www.google.com/s2/favicons?sz=128&domain='+domain;
    var ddg='https://icons.duckduckgo.com/ip3/'+domain+'.ico';
    var styHi=sty+'image-rendering:-webkit-optimize-contrast;';
    return'<img src="'+hi+'" alt="'+fixed+'" width="'+size+'" height="'+size+'" style="'+styHi+'" loading="eager" '
      +'onerror="if(!this.dataset.f){this.dataset.f=1;this.src=\''+ddg+'\';}else{this.src=\''+fbUri+'\';this.onerror=null;}">';
  }
  return'<img src="'+fbUri+'" alt="'+fixed+'" width="'+size+'" height="'+size+'" style="'+sty+'">';
};

// FAVICON-FIXER v2: herschrijf Google s2-favicons EN dode Clearbit-logo's naar DuckDuckGo-icons,
// en maak imgs die door een eerdere onerror op display:none staan weer zichtbaar.
(function(){
  function pvFixFavicons(){
    var imgs=document.querySelectorAll('img[src*="logo.clearbit.com"],img[src*="dl.svgcdn.com"]');
    for(var i=0;i<imgs.length;i++){
      var im=imgs[i];
      try{
        var src=im.getAttribute('src')||'';
        var dom='';
        var m1=src.match(/[?&]domain=([^&]+)/);
        if(m1)dom=decodeURIComponent(m1[1]);
        var m2=src.match(/logo\.clearbit\.com\/([^?\/]+)/);
        if(!dom&&m2)dom=m2[1];
        if(!dom&&src.indexOf('dl.svgcdn.com')>=0){
          var k=(src.match(/cbi\/([a-z0-9-]+)-\d+\.png/)||[])[1]||'';
          if(k&&window.PV_LOGO_DOMAINS&&PV_LOGO_DOMAINS[k])dom=PV_LOGO_DOMAINS[k];
        }
        if(dom){
          im.onerror=null;
          im.src='https://www.google.com/s2/favicons?sz=128&domain='+dom;
          if(im.style&&im.style.display==='none')im.style.display='';
        }
      }catch(e){}
    }
  }
  if(document.readyState!=='loading')pvFixFavicons();
  else document.addEventListener('DOMContentLoaded',pvFixFavicons);
  try{
    new MutationObserver(pvFixFavicons).observe(document.documentElement,{childList:true,subtree:true});
  }catch(e){}
})();
